import React, {useState} from 'react'

import './weekly-ads-product.scss'
import ProductCardTheme2 from 'components/ProductCardTheme2'
import ProductPreviewTheme2 from 'routes/product-description-theme2/ProductPreviewTheme2'

function WeeklyAdsProduct({productInfo, error}) {
  const [activeItem, setActiveItem] = useState('')

  if (error) {
    return (
      <div className='weekly-product-wrap'>
        <div className='error-message'>
          <h2>Oops!!</h2>
          <span>
            We couldn't find this item. It may be disabled or unavailable.
          </span>
        </div>
      </div>
    )
  }
  if (productInfo?.length === 1) {
    // single product
    return (
      <ProductPreviewTheme2
        productDetails={productInfo[0]}
        productInfo={{}}
      />
    )
  }

  return (
    <div className='weekly-product-wrap-product'>
      <div className='weekly-product'>
        {productInfo.map(product => {
          return (
            <ProductCardTheme2
              product={product}
              activeItem={activeItem}
              setActiveItem={setActiveItem}
              key={product.id}
            />
          )
        })}
      </div>
    </div>
  )
}

export default WeeklyAdsProduct
